import React from 'react'
import "./Benifits_Component.css";

const Benifits_Component = ({className,title,description}) => {
    return (
        <div className={`Benifits_Component ${className}`}>
            <div className="row mb-5">
                <div className="col-md-1 col-1">
                    <div className="dot-holder"></div>
                </div>
                <div className="col-md-11 col-11">
                    <div className="text-holder">
                        <div className="list-heading-holder">
                            <h4>{title}</h4>
                        </div>

                        <div className="list-text-holder">
                            <p>{description}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Benifits_Component
